"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInput = validateInput;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function validateInput(columnDef, data) {
  if (columnDef.validate) {
    var validateResponse = columnDef.validate(data);
    switch ((0, _typeof2["default"])(validateResponse)) {
      case 'object':
        return _objectSpread({}, validateResponse);
      case 'boolean':
        return {
          isValid: validateResponse,
          helperText: ''
        };
      case 'string':
        return {
          isValid: false,
          helperText: validateResponse
        };
      default:
        return {
          isValid: true,
          helperText: ''
        };
    }
  }
  return {
    isValid: true,
    helperText: ''
  };
}